import {
  LANDSCAPE_MOBILE_MAX_WIDTH_FALLBACK,
  LANDSCAPE_TABLET_MAX_WIDTH_FALLBACK,
  PORTRAIT_MOBILE_MAX_WIDTH_FALLBACK,
  PORTRAIT_TABLET_MAX_WIDTH_FALLBACK,
} from 'technical/media/config';

import { detectDeviceTypeByUserAgent } from './detect-device-type-by-user-agent';

export enum ScreenOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
}

export const getDeviceInfo = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const userAgentString = navigator.userAgent;

  const { isMobileUA, isTabletUA } =
    detectDeviceTypeByUserAgent(userAgentString);

  let orientation = ScreenOrientation.Portrait;
  if (window.screen.orientation && window.screen.orientation.type) {
    orientation = window.screen.orientation.type.includes('portrait')
      ? ScreenOrientation.Portrait
      : ScreenOrientation.Landscape;
  } else {
    orientation =
      width > height ? ScreenOrientation.Landscape : ScreenOrientation.Portrait;
  }

  let isMobile = isMobileUA;
  let isTablet = isTabletUA;

  // Fallback if user agent failed
  if (!isMobile && !isTablet) {
    if (orientation === ScreenOrientation.Portrait) {
      if (width <= PORTRAIT_MOBILE_MAX_WIDTH_FALLBACK) {
        isMobile = true;
      } else if (width <= PORTRAIT_TABLET_MAX_WIDTH_FALLBACK) {
        isTablet = true;
      }
    } else {
      if (width <= LANDSCAPE_MOBILE_MAX_WIDTH_FALLBACK) {
        isMobile = true;
      } else if (width <= LANDSCAPE_TABLET_MAX_WIDTH_FALLBACK) {
        isTablet = true;
      }
    }
  }

  return {
    isMobile,
    isTablet,
    orientation,
    userAgent: userAgentString,
  };
};
